import React from 'react';

// Component styles
import classes from "./ExternalLoginButtonContainer.module.scss";

export default function ExternalLoginButtonContainer(props) {

  return (
    <div className={classes.socialBtn}>
      {props.children}
    </div>
  );
}